module.exports = __webpack_public_path__ + "img/ic-help-filled.82b39862.svg";